import { render, staticRenderFns } from "./ReportIcon.vue?vue&type=template&id=24504d6e&scoped=true&"
import script from "./ReportIcon.vue?vue&type=script&lang=js&"
export * from "./ReportIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReportIcon.vue?vue&type=style&index=0&id=24504d6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24504d6e",
  null
  
)

export default component.exports